import { environment } from "environments/environment";


// PROD
export const SPLENDID_INSTANCE_URL: string = environment.URL_API;
export const SRD_PUBLIC_API_KEY: string = environment.APIKEY;
export const DREAMFACTORY_INSTANCE_URL: string = 'https://dm.qainformatica.com.mx/';
export const DREAMFACTORY_DB_SERVICE: string = environment.service;
export const DREAMFACTORY_FILE_STORAGE = 'srd-aws-filestorage'
export const SRD_VERSION: string = 'Beta 1.0';
export const PASSWORD_ADMIN: string = '09Apar01';
export const VERSION: string = environment.version;
export const DREAMFACTORY_DB_SERVICE_MONGO: string = 'mongodb';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/config/constants.ts